import {useSearchParams} from 'react-router'
import TripListing from '@/customComponents/uiComponents/global/TripListing.jsx'
import RideTabNav from '@/customComponents/uiComponents/global/RideTabNav.jsx'
import {useOngoingTrips} from '@/hooks/useTrips'

export default function OngoingRides() {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = Math.max(1, parseInt(searchParams.get('page'), 10) || 1)
    const setPage = (next) => {
        const params = new URLSearchParams(searchParams)
        if (next > 1) params.set('page', String(next))
        else params.delete('page')
        setSearchParams(params, {replace: true})
    }
    // Use isPlaceholderData (true only while switching pages) — NOT isFetching — to
    // drive the list's fade. The background poll flips isFetching constantly, which
    // would pulse the whole list; isPlaceholderData stays false during polls.
    const {data, isLoading, isPlaceholderData} = useOngoingTrips({page})

    return (
        <div className="flex flex-col gap-5 max-md:gap-3">
            <h2 className="max-md:hidden">On Going Rides</h2>
            <RideTabNav/>
            <TripListing
                trips={data?.trips || []}
                heading="On Going Rides"
                showDark={false}
                rideType="ongoing"
                isLoading={isLoading}
                isFetching={isPlaceholderData}
                pagination={data?.pagination}
                page={page}
                onPageChange={setPage}
            />
        </div>
    )
}
